import { request } from '../request'

export const email = {
  sendEmail: function (
    to: string[],
    subject: string,
    body: string,
    files?: { file: Blob; filename: string }[]
  ) {
    const formData = new FormData()
    formData.append('to', to.join(','))
    formData.append('subject', subject)
    formData.append('body', body)

    if (files && files.length) {
      for (const f of files) {
        formData.append('file', f.file, f.filename)
      }
    }
    return request.post(`email`, formData)
  }
}
